export const compareDates = (date1, date2) => {
  const normalize = d => {
    // If it's already YYYY-MM-DD, trust it
    if (typeof d === "string" && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
      return d;
    }

    // Otherwise, parse as Date and convert to YYYY-MM-DD in local time
    const date = new Date(d);
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  const n1 = normalize(date1);
  const n2 = normalize(date2);

  return n1 === n2;
};


export const formatToApiDate = date => `${(date.getMonth() > 8) ? (date.getMonth() + 1) : (`0${date.getMonth() + 1}`)}/${(date.getDate() > 9) ? date.getDate() : (`0${date.getDate()}`)}/${date.getFullYear()}`;

export const formatToApiDateUTC = date => 
  `${(date.getUTCMonth() > 8 ? date.getUTCMonth() + 1 : `0${date.getUTCMonth() + 1}`)}/` +
  `${(date.getUTCDate() > 9 ? date.getUTCDate() : `0${date.getUTCDate()}`)}/` +
  `${date.getUTCFullYear()}`;

export const abbreviatedDays = [
  'SUN',
  'MON',
  'TUE',
  'WED',
  'THU',
  'FRI',
  'SAT',
];


// For DateTime picker

export const formatDateYYYYMMDD = (date) => {
  const selectedDate = new Date(date);
  return (
    `${selectedDate.getFullYear()
    }-${
      selectedDate.getMonth() + 1 < 10
        ? `0${selectedDate.getMonth() + 1}`
        : selectedDate.getMonth() + 1
    }-${
      selectedDate.getDate() < 10 ? `0${selectedDate.getDate()}` : selectedDate.getDate()}`
  );
};

export const formatDateMMDDYYYY = (date) => {
  const selectedDate = new Date(date);
  return (
    `${selectedDate.getMonth() + 1 < 10
      ? `0${selectedDate.getMonth() + 1}`
      : selectedDate.getMonth() + 1
    }/${
      selectedDate.getDate() < 10 ? `0${selectedDate.getDate()}` : selectedDate.getDate()
    }/${
      selectedDate.getFullYear()}`
  );
};


function getDayNumber(abbreviatedDay) {
  const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  return abbreviatedDay.map(day => days.indexOf(day.trim().toLowerCase()));
}


const generateRecurrentDates = (startDate, endDate, selectedDays) => {
  const recurrentDates = [];
  selectedDays = getDayNumber(selectedDays);

  // Generate a date range between the start and end dates
  for (let date = new Date(startDate); date <= new Date(endDate); date.setDate(date.getDate() + 1)) {
    // If the date is a selected day, add it to the recurrent dates array
    if (selectedDays.some(selectedDay => date.getDay() === selectedDay)) {
      recurrentDates.push(new Date(date));
    }
  }
  return recurrentDates;
};

function convertToArray(input) {
  if (typeof input === 'string') {
    return input.split(','); // convert the string to a single-element array
  }
  return input;
}

function setMidnight(date) {
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
  date.setUTCHours(0);
  date.setUTCMinutes(0);
  date.setUTCSeconds(0);
  date.setUTCMilliseconds(0);
  return date;
}

function isDateIncluded(dateArray, selectedDate) {
  return dateArray.some(date => date.getFullYear() === selectedDate.getFullYear()
    && date.getMonth() === selectedDate.getMonth()
    && date.getDate() === selectedDate.getDate());
}

export const validateIfNewItemAnyDateExist = (existingItem, newItem) => {
  let existingStartDate = new Date(existingItem.StartDate);
  existingStartDate = setMidnight(existingStartDate);

  let existingEndDate = new Date(existingItem.EndDate);
  existingEndDate = setMidnight(existingEndDate);

  let newStartDate = new Date(newItem.StartDate);
  newStartDate = setMidnight(newStartDate);

  let newEndDate = new Date(newItem.EndDate);
  newEndDate = setMidnight(newEndDate);

  // Check if new item's start or end date falls between existing item's start and end date
  if (newStartDate >= existingStartDate || newEndDate <= existingEndDate) {
    // Generate recurrent dates for each item
    if(!existingItem.DayOfWeekFreqcy){
      existingItem.DayOfWeekFreqcy = existingItem.DayofWeekFreqcy
    }
    if(!existingItem.DayofWeekFreqcy){
      existingItem.DayofWeekFreqcy = existingItem.DayOfWeekFreqcy
    }
    const existingRecurrentDates = generateRecurrentDates(existingStartDate, existingEndDate, convertToArray(existingItem.DayOfWeekFreqcy));
    const newRecurrentDates = generateRecurrentDates(newStartDate, newEndDate, convertToArray(newItem.DayOfWeekFreqcy));

    // Check if any recurrent dates overlap
    for (let i = 0; i < newRecurrentDates.length; i += 1) {
      if (isDateIncluded(existingRecurrentDates, newRecurrentDates[i])) {
        return false;
      }
    }
  }

  return true;
};

export const formatDate = (dateStr) => {
  const [year, month, day] = dateStr.split("-");

  let d = new Date(year, month - 1, day); // months are zero-based
return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;

}

function parseMMDDYYYY(dateStr) {
  const [month, day, year] = dateStr.split("/").map(Number);
  return new Date(year, month - 1, day); 
}

export const formatShiftedDateText = (selectedDate, offsetDays) => {
  let d = parseMMDDYYYY(selectedDate);
  d.setDate(d.getDate() + offsetDays);

  let month = d.getMonth() + 1; // months are zero-based
let day = d.getDate();
let year = d.getFullYear();

let formatted = `${month}/${day}/${year}`;
  return formatted;
}


export const formatTodaydDate = (selectedDate, offsetDays) => {
  const [month, day, year] = selectedDate.split("/").map(Number);
  let d = new Date(Date.UTC(year, month - 1, day));
  d.setUTCDate(d.getUTCDate() + offsetDays);
  return d; // <-- return Date object, not string
}

export const formatShiftedDate = (selectedDate, offsetDays) => {
  const [month, day, year] = selectedDate.split("/").map(Number);
  let d = new Date(year, month - 1, day);
  d.setDate(d.getDate() + offsetDays);
  return d; // <-- return Date object, not string
}

export const formatShiftedMonth = (selectedDate, offsetMonths) => {
  const [month, day, year] = selectedDate.split("/").map(Number);
  let d = new Date(year, month - 1, day);
  d.setMonth(d.getMonth() + offsetMonths);
  return d; // <-- return Date object, not string
};

export function getShiftedApiMonthMMDDYYYY(inputDate, offsetMonth = 0, timeZone = "UTC") {
  let year, month, day;

  if (inputDate.includes("-")) {
    // Format: YYYY-MM-DD
    [year, month, day] = inputDate.split("-").map(Number);
  } else if (inputDate.includes("/")) {
    // Format: MM/DD/YYYY
    [month, day, year] = inputDate.split("/").map(Number);
  } else {
    throw new Error("Unsupported date format");
  }

  let d = new Date(year, month - 1, day);

  // Apply shift
  d.setMonth(d.getMonth() + offsetMonth);

  // Format as MM/DD/YYYY
  const mm = d.getMonth() + 1;
  const dd = d.getDate();
  const yyyy = d.getFullYear();

  return `${mm > 9 ? mm : `0${mm}`}/${dd > 9 ? dd : `0${dd}`}/${yyyy}`;
}

export function getShiftedApiDateMMDDYYYY(inputDate, offsetDays = 0, timeZone = "UTC") {
  let year, month, day;

  if (inputDate.includes("-")) {
    // Format: YYYY-MM-DD
    [year, month, day] = inputDate.split("-").map(Number);
  } else if (inputDate.includes("/")) {
    // Format: MM/DD/YYYY
    [month, day, year] = inputDate.split("/").map(Number);
  } else {
    throw new Error("Unsupported date format");
  }

  let d = new Date(year, month - 1, day);

  // Apply shift
  d.setDate(d.getDate() + offsetDays);

  // Format as MM/DD/YYYY
  const mm = d.getMonth() + 1;
  const dd = d.getDate();
  const yyyy = d.getFullYear();

  return `${mm > 9 ? mm : `0${mm}`}/${dd > 9 ? dd : `0${dd}`}/${yyyy}`;
}

export function getShiftedApiDateYYYYMMDD(inputDate, offsetDays = 0, timeZone = "UTC") {
  let year, month, day;

  if (inputDate.includes("-")) {
    // Format: YYYY-MM-DD
    [year, month, day] = inputDate.split("-").map(Number);
  } else if (inputDate.includes("/")) {
    // Format: MM/DD/YYYY
    [month, day, year] = inputDate.split("/").map(Number);
  } else {
    throw new Error("Unsupported date format");
  }

  let d = new Date(year, month - 1, day);

  // Apply shift
  d.setDate(d.getDate() + offsetDays);

  // Format as MM/DD/YYYY
  const mm = d.getMonth() + 1;
  const dd = d.getDate();
  const yyyy = d.getFullYear();
  return `${yyyy}-${mm > 9 ? mm : `0${mm}`}-${dd > 9 ? dd : `0${dd}`}`;
}